<template>
  <div :class="classes">
    <div class="wf-flex wf-justify-between wf-items-center">
      <div class="wf-flex wf-items-center">
        <img class="wf-w-48" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt="">  
        <nav class="wf-ml-8">
          <ul class="wf-flex" :class="containerNavLinkClasses">
            <template v-for="(navLink, index) in navLinks">
              <HeaderNavLink
                :key="index"
                :navLink="navLink"
                :classes="navLinkClasses"
                :styles="navLinkStyles"
                :subMenuContainerClasses="subMenuContainerClasses"
                :subMenuContainerStyles="subMenuContainerStyles"
                :subMenuClasses="subMenuClasses"
                :megaMenuFullWidth="megaMenuFullWidth"
                :subMenuStyles="subMenuStyles"
                :megaMenuClasses="megaMenuClasses"
                :megaMenuStyles="megaMenuStyles"
                :megaMenuContainerClasses="megaMenuContainerClasses"
                :megaMenuContainerStyles="megaMenuContainerStyles"
                :megaMenuTitleClasses="megaMenuTitleClasses"
                :megaMenuTitleStyles="megaMenuTitleStyles"
              />
            </template>
          </ul>
        </nav>
      </div>
      <div v-show="hasCta">
        <div :class="ctaClasses" :style="ctaStyles">
            <div v-text="ctaText"></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderContract from '../../contracts/HeaderContract'
  export default HeaderContract.extend({})
</script>